import { Flex, Text } from '@nula/core-ui';
import styles from './surface-status-line.module.css';

export function SurfaceStatusLine({ text }: { text: string }) {
  return (
    <Flex role="status" align="center" gap={2} className={styles.line}>
      <Flex component="span" aria-hidden="true" className={styles.dot} />
      <Text size="sm" type="secondary">{text}</Text>
    </Flex>
  );
}
